














import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { Storage } from 'aws-amplify';


@Component({
    name: 'Hero',
    components: {

    }
})

export default class AppletGallery extends Vue {
    @Prop()
    title!: string;

    @Prop()
    imageKey!: string;

    private heroImageLoaded = false;
    private coverImageUrl = null;

    mounted() {
        if (this.imageKey) {
            this.onChangeImageKey(this.imageKey);
        }
    }

    @Watch('imageKey')
    private async onChangeImageKey(key) {
        this.coverImageUrl = await Storage.get(key);
    }
}
